module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "notifications",
    staticStyle: {
      "margin-bottom": "3em"
    }
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.cninsurance.cninsurance_name) + "\r\n                        "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cninsurance"
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setComponentView('editCNinsurance')
      }
    }
  }, [_vm._v("Edit CNinsurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.setGetComponentView('viewSubmittedForms')
      }
    }
  }, [_vm._v("View Submitted Forms")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.component_view.viewFiledComplaints) ? _c('div', [_c('h4', [_vm._v("viewFiledComplaints")])]) : (_vm.component_view.viewFiledClaims) ? _c('div', [_c('h4', [_vm._v("viewFiledClaims")])]) : (_vm.component_view.viewSubmittedForms) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wn-card"
  }, [(_vm.load_processes) ? _c('div', {
    staticClass: "cx-loading-sm center"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.cninsurance_forms), function(form_acc, index) {
    return _c('div', {
      staticClass: "wn-card"
    }, [_c('h4', [_c('b', [_vm._v("Submitted by: ")]), _vm._v(_vm._s(form_acc.cninsurance_account_name))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.togglePanView('FAC' + index)
        }
      }
    }, [_vm._v("collaspe "), _c('i', {
      staticClass: "fa fa-angle-down"
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('table', {
      staticClass: "table",
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'FAC' + index
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((form_acc.cninsurance_account_forms), function(form, fndex) {
      return _c('tr', {
        attrs: {
          "data-expanded": "true"
        }
      }, [_c('td', [_vm._v(_vm._s(++fndex))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_policy_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.cninsurance_form_sent_status_name))]), _vm._v(" "), _c('td', [(form.cninsurance_form_pay_status == 1) ? _c('span', {
        staticStyle: {
          "line-height": "0.8"
        }
      }, [_vm._v("Paid")]) : _c('span', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Not Paid")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Object.keys(form.cninsurance_filed_claims).length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Object.keys(form.cninsurance_filed_complaints).length))]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-success",
        on: {
          "click": function($event) {
            _vm.setGetComponentView('viewForm', form);
            _vm.storeActiveToggleIndex('form', 'FAC' + index);
          }
        }
      }, [_vm._v("View")])])])
    }))])])
  })], 2)]) : (_vm.component_view.viewForm) ? _c('div', [_c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                  Form  Details\r\n                                "), _c('a', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.setGetComponentView('viewSubmittedForms');
        _vm.togglePanView(_vm.toggle_indexes.form)
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "2em 0"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Form Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_id))])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Policy Number: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_form.cninsurance_form_policy_number))])])]), _vm._v(" "), (_vm.cninsurance_form.cninsurance_form_certificate_url != 'nil') ? _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "href": _vm.cninsurance_form.cninsurance_form_certificate_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Certificate")])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('h5', [_vm._v("Form entries")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, _vm._l((_vm.cninsurance_form.cninsurance_form_entries), function(cform, cfndex) {
    return _c('div', {
      staticClass: "row"
    }, [((cform.cninsurance_form_entry_type % 2) != 0) ? _c('div', {
      staticClass: "wn-fleft wn-h-list"
    }, [_c('h6', {
      staticStyle: {
        "font-size": "16px !important"
      }
    }, [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#413f3f !important"
      }
    }, [_vm._v(_vm._s(cform.cninsurance_form_entry_value))])]), _c('br')]) : _vm._e(), _vm._v(" "), ((cform.cninsurance_form_entry_type % 2) == 0) ? _c('div', {
      staticClass: "wn-fright wn-h-list"
    }, [_c('h6', {
      staticStyle: {
        "font-size": "16px !important"
      }
    }, [_c('b', [_vm._v(_vm._s(cform.cninsurance_form_entry_type_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#413f3f !important"
      }
    }, [_vm._v(_vm._s(cform.cninsurance_form_entry_value))])]), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "2em 0"
    }
  }, [_c('div', {}, [_c('h4', [_vm._v("CLAIMS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_claims), function(cclaim, cclndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(cclaim.cninsurance_claim_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(cclaim.cninsurance_claim_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setContentView('claim_content', cclaim, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "2em 0"
    }
  }, [_c('div', {}, [_c('h4', [_vm._v("COMPLAINTS")]), _vm._v(" "), _vm._l((_vm.cninsurance_form.cninsurance_filed_complaints), function(ccomp, ccondex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-3 col-xs-12"
    }, [_c('div', {
      staticClass: "wn-h-list"
    }, [_c('h5', [_c('i', {
      staticClass: "fa fa-table",
      staticStyle: {
        "font-size": "1.3em",
        "color": "#22baae",
        "font-weight": "bold"
      }
    }), _vm._v(" " + _vm._s(ccomp.cninsurance_complaint_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(ccomp.cninsurance_complaint_reg_date))]), _vm._v(" "), _c('button', {
      staticClass: "pull-right btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setContentView('complaint_content', ccomp, '')
        }
      }
    }, [_vm._v("view details")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : (_vm.component_view.editCNinsurance) ? _c('div', [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(2), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_name),
      expression: "cninsurance.cninsurance_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_description),
      expression: "cninsurance.cninsurance_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_tagline),
      expression: "cninsurance.cninsurance_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_tagline),
      expression: "cninsurance.cninsurance_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_commission),
      expression: "cninsurance.cninsurance_commission"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_commission = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_commission_type),
      expression: "cninsurance.cninsurance_commission_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance.cninsurance_commission_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Cash")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "P"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_logo),
      expression: "cninsurance.cninsurance_logo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_logo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_logo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance.cninsurance_banner_image),
      expression: "cninsurance.cninsurance_banner_image"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cninsurance.cninsurance_banner_image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance.cninsurance_banner_image = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.process_loading) ? _c('div', {
    staticClass: "cx-loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.editCNinsuranceDetails
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.setComponentView('')
      }
    }
  }, [_vm._v("Cancel")])])])])]) : _c('div', [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                      \"paging\": {\r\n                                      \"enabled\": true\r\n                                      },\r\n                                      \"filtering\": {\r\n                                      \"enabled\": true\r\n                                      },\r\n                                      \"sorting\": {\r\n                                      \"enabled\": true\r\n                                      }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Created")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_reg_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Tagline")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_tagline))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNinsurance Commission")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cninsurance.cninsurance_commission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNinsurance Commission Type")]), _vm._v(" "), _c('td', [(_vm.cninsurance.cninsurance_commission_type == 'C') ? _c('span', [_vm._v("CASH")]) : _vm._e(), _vm._v(" "), (_vm.cninsurance.cninsurance_commission_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Logo")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": _vm.cninsurance.cninsurance_logo,
      "width": "200",
      "height": "160"
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Banner Image")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": _vm.cninsurance.cninsurance_banner_image,
      "width": "200",
      "height": "160"
    }
  })])])])]), _vm._v(" "), _vm._m(12), _c('br'), _vm._v(" "), _c('table', _vm._l((_vm.cninsurance.cninsurance_payment_settings), function(fv, index) {
    return _c('tr', [_c('div', [_c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("\r\n                                            " + _vm._s(fv.cninsurance_form_variable_1_name)), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("(" + _vm._s(fv.cninsurance_form_variable_2_name) + ")")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("NGN" + _vm._s(fv.cninsurance_form_price))]), _c('br'), _vm._v(" "), (_vm.component_attr_view['fva_p' + index]) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (fv.cninsurance_form_price),
        expression: "fv.cninsurance_form_price"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (fv.cninsurance_form_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          fv.cninsurance_form_price = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.setCNinsuraceFormPrice(_vm.cninsurance, fv)
        }
      }
    }, [_vm._v("OK\r\n                                                "), (_vm.process_loading) ? _c('span', [_c('img', {
      attrs: {
        "src": "/static/assets/images/loader.gif",
        "height": "20px"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('')
        }
      }
    }, [_vm._v("CANCEL")])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('fva_p' + index)
        }
      }
    }, [_vm._v("edit price")])])])])])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(13), _c('br'), _vm._v(" "), _c('table', _vm._l((_vm.cninsurance.cninsurance_discounts), function(cd, index) {
    return _c('tr', [_c('div', [_c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("Code")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("Start")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v("End")]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(cd.cninsurance_discount_code))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [(cd.cninsurance_discount_type == 'C') ? _c('span', [_vm._v("NGN" + _vm._s(cd.cninsurance_discount_value))]) : (cd.cninsurance_discount_type == 'P') ? _c('span', [_vm._v(_vm._s(cd.cninsurance_discount_value) + "%")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(cd.cninsurance_discount_start_date))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_vm._v(_vm._s(cd.cninsurance_discount_expiry_date))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px"
      }
    }, [(cd.cninsurance_discount_status == 0) ? _c('span', {
      staticStyle: {
        "padding": "3px",
        "font-size": "13px",
        "border-radius": "5px",
        "background-color": "#ff0000",
        "color": "#ffffff"
      }
    }, [_vm._v("OFF")]) : _vm._e(), _vm._v(" "), (cd.cninsurance_discount_status == 1) ? _c('span', {
      staticStyle: {
        "padding": "3px",
        "font-size": "13px",
        "border-radius": "5px",
        "background-color": "#3da315",
        "color": "#ffffff"
      }
    }, [_vm._v("ON")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('cndis' + index)
        }
      }
    }, [_vm._v("edit")])])])]), _vm._v(" "), (_vm.component_attr_view['cndis' + index]) ? _c('div', [_c('div', [_c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Code: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_code),
        expression: "cd.cninsurance_discount_code"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (cd.cninsurance_discount_code)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_code = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Type: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_type),
        expression: "cd.cninsurance_discount_type"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          cd.cninsurance_discount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("Cash")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("%")])])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Amount: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_value),
        expression: "cd.cninsurance_discount_value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (cd.cninsurance_discount_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_value = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Start Date: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_start_date),
        expression: "cd.cninsurance_discount_start_date"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (cd.cninsurance_discount_start_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_start_date = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Discount Expiry Date: ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_expiry_date),
        expression: "cd.cninsurance_discount_expiry_date"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (cd.cninsurance_discount_expiry_date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          cd.cninsurance_discount_expiry_date = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('b', [_vm._v("Activate/Deactivate: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cd.cninsurance_discount_status),
        expression: "cd.cninsurance_discount_status"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          cd.cninsurance_discount_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("ON")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("OFF")])])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.updateDiscount(cd)
        }
      }
    }, [_vm._v("OK\r\n                                            "), (_vm.process_loading) ? _c('span', [_c('img', {
      attrs: {
        "src": "/static/assets/images/loader.gif",
        "height": "20px"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.setComponentAttributeView('')
        }
      }
    }, [_vm._v("CANCEL")])])]) : _vm._e()])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.component_view.add_new_discount) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setComponentView('add_new_discount')
      }
    }
  }, [_vm._v("Add new CNinsurance Discounts")]) : _vm._e(), _vm._v(" "), (_vm.component_view.add_new_discount) ? _c('div', [_vm._m(14), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "background-white p20"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_code),
      expression: "cninsurance_discount.discount_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Unique Discount Code"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_start_date),
      expression: "cninsurance_discount.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_expiry_date),
      expression: "cninsurance_discount.discount_expiry_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_expiry_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_expiry_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Type: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_type),
      expression: "cninsurance_discount.discount_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cninsurance_discount.discount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Cash")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "P"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discount Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cninsurance_discount.discount_value),
      expression: "cninsurance_discount.discount_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cninsurance_discount.discount_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cninsurance_discount.discount_value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.process_loading) ? _c('div', {
    staticClass: "cx-loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addNewDiscount
    }
  }, [_vm._v("Add discount")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.setComponentView('')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [(_vm.load_processes) ? _c('div', {
    staticClass: "cx-loading-sm center"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                  CNinsurance Listings\r\n                ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                    \"paging\": {\r\n                      \"enabled\": true\r\n                    },\r\n                    \"filtering\": {\r\n                      \"enabled\": true\r\n                    },\r\n                    \"sorting\": {\r\n                      \"enabled\": true\r\n                    }}"
    }
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.cninsurance_listings), function(cninsurance, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_cost))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_total_forms))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cninsurance.cninsurance_total_amount_sold))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cninsurance)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "form_content",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "claim_content",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Claim Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_claim.cninsurance_claim_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Claim Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_title) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_details) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_claim.cninsurance_claim_reg_date) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "complaint_content",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('paywith')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "inherit"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Complaint Details"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Form Policy Id: "), _c('b', [_vm._v(_vm._s(_vm.cninsurance_complaint.cninsurance_complaint_form_policy_id))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "border": "#22baae solid 2px",
      "padding": "3em",
      "width": "inherit"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wn-fleft"
  }, [_c('h6', [_c('b', [_vm._v("Complaint Title ")]), _c('br'), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_title) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Complaint Details")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_details) + "\r\n                                        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Date Submitted")]), _c('br'), _vm._v("\r\n                                            " + _vm._s(_vm.cninsurance_complaint.cninsurance_complaint_reg_date) + "\r\n                                        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wn-card"
  }, [_c('h4', [_vm._v("View Submitted Forms")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Form Ref")]), _vm._v(" "), _c('th', [_vm._v("Policy Id")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Paid")]), _vm._v(" "), _c('th', [_vm._v("Claims")]), _vm._v(" "), _c('th', [_vm._v("Complaints")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("Edit CNinsurance Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Description"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Tagline"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Admin Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*(for mailing forms)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Commission"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Commission Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Logo Link"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("CNinsurance Banner Image Link"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow",
    staticStyle: {
      "clear": "both",
      "margin-bottom": "3em",
      "display": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("CNinsurance Form Pricing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("CNinsurance Discounts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('u', [_vm._v("Add new CNinsurance Discount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Discount Code"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Start Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Expiry Date"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Service Cost")]), _vm._v(" "), _c('th', [_vm._v("Total Forms")]), _vm._v(" "), _c('th', [_vm._v("Total Amount")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "clear": "both",
      "word-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\r\n                    form_content\r\n                    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11f9840d"}!./src/components/CNinsurance/template.html
// module id = 154
// module chunks = 0